import PlaceAutocomplete from "../components/PlaceAutocomplete.tsx";
import PracticesList from "../components/PracticesList.tsx";
import PracticeInfoWindow from "../components/PracticeInfoWindow.tsx";
import PracticesMapContainer from "../components/PracticesMapContainer.tsx";
import {actions, useApp} from "../providers/AppProvider.tsx";
import {useMap} from "@vis.gl/react-google-maps";
import clsx from "clsx";
import {useScrollHandler} from "../hooks/useScrollHandler.tsx";


const DesktopApp = () => {

    const {dispatch} = useApp()
    const scrollableListRef = useScrollHandler();
    const map = useMap()

    return (
        <div>
            <div className="flex">
                <div className={"flex-none relative"}
                     style={{'width': 508}}
                >
                    <div className="search-wrapper">

                        <PlaceAutocomplete onPlaceSelect={(place) => {
                            if (place) {
                                map?.setValues({
                                    userEnteredSearch: 1
                                })
                                dispatch(actions.setUserLocation(place))
                            }
                        }}/>

                    </div>
                    <div className={clsx(
                        "scrollable-list h-[calc(100vh-65px)] mt-[65px] overflow-auto",
                    )}
                         ref={scrollableListRef}>
                        <PracticesList/>
                    </div>
                    <PracticeInfoWindow/>
                </div>
                <div className={"grow"}>
                    <PracticesMapContainer/>
                </div>
            </div>


        </div>
    )
}

export default DesktopApp;